// Appearance (vault/Apps/Forge/Pages/Appearance.md) — the org theme-defaults
// client. Same shape as src/api/kbs.ts: a factory over fetch, so a test hands
// in its own transport and the page never touches the network.

import { appFetch } from './transport';
export interface OrgAppearance {
  base: string;
  accent: string;
  radius: string;
  updatedBy: string | null;
  updatedAt: string | null;
}

export interface AppearanceClient {
  load(org: string): Promise<OrgAppearance>;
  save(org: string, choice: { base: string; accent: string; radius: string }): Promise<OrgAppearance>;
}

export function createAppearanceClient(fetchImpl: typeof fetch = appFetch): AppearanceClient {
  const answer = async (res: Response, what: string): Promise<OrgAppearance> => {
    const body = (await res.json().catch(() => null)) as
      | { appearance?: OrgAppearance; reason?: string }
      | null;
    if (!res.ok || !body?.appearance) {
      // the server's own sentence when it gave one — refusals are relayed, not paraphrased
      throw new Error(body?.reason ?? `${what} answered ${res.status}`);
    }
    return body.appearance;
  };
  return {
    async load(org) {
      const res = await fetchImpl(`/api/${encodeURIComponent(org)}/appearance`);
      return answer(res, 'GET appearance');
    },
    async save(org, choice) {
      const res = await fetchImpl(`/api/${encodeURIComponent(org)}/appearance`, {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(choice),
      });
      return answer(res, 'PUT appearance');
    },
  };
}
